document.addEventListener('DOMContentLoaded', function () {
  const popupOverlay = document.getElementById('nutrition-popup-overlay');
  const popupImage = document.getElementById('nutrition-popup-img');
  const popupClose = document.getElementById('nutrition-popup-close');
  const triggers = document.querySelectorAll('.nutrition-popup-trigger');

  triggers.forEach(trigger => {
      trigger.addEventListener('click', function () {
      const imgSrc = this.getAttribute('src');
      popupImage.setAttribute('src', imgSrc);
      popupOverlay.style.display = 'flex';
    });
  });

  popupClose.addEventListener('click', function() {
    popupOverlay.style.display = 'none';
  });

  popupOverlay.addEventListener('click', function(e) {
    if (e.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  });
});